<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap justify-center>
				<v-flex xs12>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            <v-icon>receipt</v-icon>
                            DANH SÁCH
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card class="mt-3">
                        <v-tabs grow v-model="current_tab">
                            <v-tab>
                                <h4 class="mb-0">Danh sách Phiếu chưa xử lý</h4>
                            </v-tab>
                            <v-tab>
                                <h4 class="mb-0">Sổ quỹ</h4>
                            </v-tab>
                        </v-tabs>
                    </v-card>
                    <v-tabs-items v-model="current_tab">
                        <v-tab-item>
                            <phieu-thu-chua-xu-ly :chosen_month="chosen_month" :current_tab="current_tab"></phieu-thu-chua-xu-ly>
                        </v-tab-item>
                        <v-tab-item>
                            <phieu-thu-co-gam :chosen_month="chosen_month" :current_tab="current_tab"></phieu-thu-co-gam>
                        </v-tab-item>
                    </v-tabs-items>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
import phieuThuChuaXuLy from "./PhieuThuChuaXuLy"
import phieuThuCoGam from './PhieuThuCoGam'

export default {
    name: "phieu-thu-co-gam-layout",
    components: {
        phieuThuChuaXuLy,
        phieuThuCoGam
    },
    data(){
        return {
            current_tab: 0,
            menu_month_picker: false,
            chosen_month: new Date().toISOString().substr(0, 7),
        }
    },
    watch: {
        current_tab(){
        }
    }
};
</script>
